import dynamic from 'next/dynamic'
import { useMemo } from 'react'

import { RenderOnFirstInteraction } from '@/components/RenderOnFirstInteraction'

import type { TLanguageSelectDesktopProps } from './LanguageSelectDesktop'

export const LazyLanguageSelectDesktop = ({
	isOpen,
	setIsOpen,
	setHasLoaded,
	...props
}: TLanguageSelectDesktopProps & {
	isOpen: boolean
	setIsOpen: (isOpen: boolean) => void
	setHasLoaded: (hasLoaded: boolean) => void
}) => {
	const DynamicLanguageSelect = useMemo(
		() =>
			dynamic(() =>
				import('./LanguageSelectDesktop').then((mod) => {
					setHasLoaded(true)
					return mod.LanguageSelectDesktop
				}),
			),
		[setHasLoaded],
	)

	return (
		<RenderOnFirstInteraction
			element={
				<DynamicLanguageSelect
					{...props}
					isOpen={isOpen}
					setIsOpen={setIsOpen}
				/>
			}
		/>
	)
}
